import React, { useEffect, useRef } from 'react';

const GMAP_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const InteractiveMap = ({ address, lat, lng, height = '400px', zoom = 20, className = '' }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || !window.google?.maps) return;
    
    const center = (lat && lng) ? { lat, lng } : null;
    
    if (center) {
      const map = new window.google.maps.Map(mapRef.current, {
        center,
        zoom,
        mapTypeId: 'satellite',
        zoomControl: true,
        scrollwheel: true,
        gestureHandling: 'greedy',
        fullscreenControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      });
      new window.google.maps.Marker({ position: center, map, title: address || '' });
      mapInstanceRef.current = map;
    } else if (address) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const loc = results[0].geometry.location;
          const map = new window.google.maps.Map(mapRef.current, {
            center: loc,
            zoom,
            mapTypeId: 'satellite',
            zoomControl: true,
            scrollwheel: true,
            gestureHandling: 'greedy',
            fullscreenControl: true,
            streetViewControl: false,
            mapTypeControl: false,
          });
          new window.google.maps.Marker({ position: loc, map, title: address });
          mapInstanceRef.current = map;
        }
      });
    }
  }, [address, lat, lng, zoom]);

  if (!GMAP_KEY || (!address && !lat)) {
    return (
      <div className={`bg-gray-200 rounded-xl flex items-center justify-center ${className}`} style={{ height }}>
        <p className="text-gray-500 text-sm">Map unavailable</p>
      </div>
    );
  }

  return <div ref={mapRef} className={`rounded-xl overflow-hidden shadow-lg ${className}`} style={{ height }} />;
};

export default InteractiveMap;
